import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";
import Logo from "../components/Logo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handle = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Accesso effettuato");
      navigate("/admin");
    } catch (err) {
      const msg = formatApiError(err?.response?.data?.detail) || err.message;
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 justify-center">
          <Logo className="w-10 h-10 text-slate-900" />
          <span className="font-serif text-xl text-slate-900">Da Pra Assicurazioni</span>
        </Link>

        <div className="mt-10 bg-white border border-slate-200 p-8">
          <div className="overline">Area riservata</div>
          <h1 className="mt-3 font-serif text-3xl text-slate-900">Accesso amministrazione</h1>
          <p className="text-sm text-slate-500 mt-2">Inserisci le tue credenziali per gestire le richieste di preventivo.</p>

          <form onSubmit={handle} className="mt-8 space-y-5" data-testid="admin-login-form">
            <div>
              <label className="text-xs uppercase tracking-wide text-slate-700 font-medium">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                className="mt-2 w-full h-11 px-3 bg-white border border-slate-300 focus:border-slate-900 focus:outline-none text-sm"
                autoComplete="username"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wide text-slate-700 font-medium">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                className="mt-2 w-full h-11 px-3 bg-white border border-slate-300 focus:border-slate-900 focus:outline-none text-sm"
                autoComplete="current-password"
              />
            </div>
            {error && (
              <div data-testid="login-error" className="text-sm text-red-600 border border-red-200 bg-red-50 px-3 py-2">{error}</div>
            )}
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full inline-flex items-center justify-center gap-2 bg-slate-900 hover:bg-slate-800 disabled:opacity-60 text-white h-11 text-sm tracking-wide"
            >
              {loading && <Loader2 size={16} className="animate-spin" />}
              Accedi
            </button>
          </form>
        </div>

        <div className="mt-6 text-center">
          <Link to="/" className="text-xs text-slate-500 hover:text-slate-900">← Torna al sito</Link>
        </div>
      </div>
    </div>
  );
}
